import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=a910a3cc"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=a910a3cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports